// Explicit #/... and #?... routes navigate through Social.Wiki unless the document opts
// into a different root with data-document-route on the kernel script.
export const DEFAULT_DOCUMENT_ROUTE = "https://social.wiki/";
